'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function TWFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-ml7y8e9a8", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-g20qe0a7p", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-pd2vvr3v5" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-pd2vvr3v5", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-ml7y8e9a8)" }, /* @__PURE__ */ React.createElement("use", { fill: "#ef0000", xlinkHref: "#mantine-pd2vvr3v5" }), /* @__PURE__ */ React.createElement("g", { mask: "url(#mantine-g20qe0a7p)" }, /* @__PURE__ */ React.createElement("path", { fill: "#2e42a5", d: "M0 0h18v14H0z" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#feffff",
        d: "M10.211 1.6l.36 2.342 2.207-.86-.86 2.207 2.341.359-1.848 1.482 1.848 1.481-2.341.36.86 2.207-2.208-.86-.359 2.341-1.481-1.848-1.482 1.848-.359-2.341-2.207.86.86-2.208L3.2 8.611 5.049 7.13 3.2 5.648l2.342-.359-.86-2.207 2.207.86.359-2.342L8.73 3.449zM8.73 4.267a2.862 2.862 0 100 5.725 2.862 2.862 0 000-5.725zm0 .573a2.29 2.29 0 110 4.58 2.29 2.29 0 010-4.58z"
      }
    ))))
  );
}

export { TWFlag };
//# sourceMappingURL=TW.mjs.map
